
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToInstructions = () => {
    document.getElementById('instructions')?.scrollIntoView({ behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/905078064479', '_blank');
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(11, 11, 14, 0.7), rgba(11, 11, 14, 0.8)), url('https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/f9fc5775f5fdd4750768a60787c3939b.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0B0B0E]/20 to-[#0B0B0E]/60"></div>
      
      <div className={`relative z-10 section-padding container-max text-center transition-all duration-1000 ${isVisible ? 'fade-in' : 'opacity-0'}`}>
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="block text-white">Şeffaf Plak Tedaviniz:</span>
            <span className="block gold-text mt-2">Estetik, Konforlu, Hızlı.</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            Kullanım talimatları, temizlik önerileri ve tedavi rehberiniz tek sayfada.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button 
              onClick={openWhatsApp}
              className="btn-primary flex items-center gap-3 text-lg micro-animation"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              WhatsApp'tan Danışın
            </button>
            
            <button 
              onClick={scrollToInstructions}
              className="btn-secondary flex items-center gap-3 text-lg micro-animation"
            >
              <i className="ri-file-list-3-line text-2xl"></i>
              Kullanım Talimatlarını Gör
            </button>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#D4AF37] rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#D4AF37] rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
